{
  "notifications": {
    "title": "Notificaciones",
    "empty": "No tienes invitaciones pendientes"
  },
  "card": {
    "title": "{{orgName}} · Invitación",
    "subtitle": "{{inviterName}} te invitó a unirte como {{role}}"
  },
  "membersCount_one": "{{count}} miembro",
  "membersCount_other": "{{count}} miembros",
  "dialog": {
    "title": "Invitación pendiente",
    "inviterAction": "te ha invitado a formar parte de la organización",
    "role": "Rol: {{role}}",
    "accept": "Aceptar invitación",
    "reject": "Rechazar",
    "confirmReject": {
      "title": "¿Rechazar invitación?",
      "description": "No podrás unirte a esta organización a menos que recibas una nueva invitación.",
      "confirm": "Rechazar",
      "cancel": "Cancelar"
    }
  },
  "acceptPage": {
    "loading": "Cargando invitación...",
    "notFound": "Esta invitación no existe o ya fue procesada.",
    "error": "No se pudo cargar la invitación.",
    "expired": "Esta invitación ya expiró.",
    "invalid": "Esta invitación ya no es válida."
  },
  "apiErrors": {
    "acceptConflict": "Ya eres miembro de esta organización",
    "acceptNotFound": "La invitación no existe o ya expiró",
    "acceptDefault": "No se pudo aceptar la invitación",
    "rejectConflict": "Esta invitación ya fue procesada",
    "rejectNotFound": "La invitación no existe o ya expiró",
    "rejectDefault": "No se pudo rechazar la invitación"
  }
}
